import * as Action from "@actions/index";

const InitialState = {
  status: "loading",
  list: [],
  error: "",
};

export default function StandDirection(state = InitialState, action: any) {
  switch (action.type) {
    case Action.Stand.Direction.SET_LIST:
      return { ...state, list: action.data };
    case Action.Stand.Direction.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Stand.Direction.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Stand.Direction.CLEAR:
      return { ...state, list: [] };
    default:
      return state;
  }
}
